import { render, staticRenderFns } from "./ElectionCandidate.vue?vue&type=template&id=5682d374&scoped=true&"
import script from "./ElectionCandidate.vue?vue&type=script&lang=js&"
export * from "./ElectionCandidate.vue?vue&type=script&lang=js&"
import style0 from "./ElectionCandidate.vue?vue&type=style&index=0&id=5682d374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682d374",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VCol})
